import { Component } from '@angular/core';

import { NewsWidgetItemComponent } from '../news-widget-item/news-widget-item.component';

@Component({
  selector: 'kh-news-widget-item-teacher',
  templateUrl: './news-widget-item-teacher.component.html',
  styleUrl: './news-widget-item-teacher.component.less',
  standalone: false
})
export class NewsWidgetItemTeacherComponent extends NewsWidgetItemComponent {

}
